module.exports = __webpack_public_path__ + "static/noodcases-9c4c20bbae4ec2c81cb6ea87fd9f0996.png";